import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import LandingPage from "@/pages/LandingPage";
import ReserveSuccess from "@/pages/ReserveSuccess";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import CookiePolicy from "@/pages/CookiePolicy";
import Accessibility from "@/pages/Accessibility";
import CookieConsent from "@/components/site/CookieConsent";
import LocalVisibilityPage from "@/pages/LocalVisibilityPage";
import IndustryPage from "@/pages/IndustryPage";
import WebsiteReviewPage from "@/pages/WebsiteReviewPage";
import GoogleBusinessProfilePage from "@/pages/GoogleBusinessProfilePage";
import NotFound from "@/pages/NotFound";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <a href="#main-content" data-testid="skip-link" className="skip-link">
          Skip to main content
        </a>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/local-visibility" element={<LocalVisibilityPage />} />
          <Route path="/website-review" element={<WebsiteReviewPage />} />
          <Route path="/google-business-profile" element={<GoogleBusinessProfilePage />} />
          <Route path="/websites-for/:slug" element={<IndustryPage />} />
          <Route path="/reserve/success" element={<ReserveSuccess />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </div>
  );
}

export default App;
